import { create } from 'zustand';

export type CheckoutStep =
  | 'ticketSelection'
  | 'attendeeDetails'
  | 'payment'
  | 'summary';

type CheckoutModalState = {
  isOpen: boolean;
  eventId?: string;
  initialPromoCode?: string;
  initialTicketTypeId?: string;
  currentStep: CheckoutStep;
  checkoutId?: string;
  onSuccess?: () => void;
  openCheckoutModal: (params: {
    eventId: string;
    initialPromoCode?: string;
    initialTicketTypeId?: string;
    currentStep?: CheckoutStep;
    checkoutId?: string;
    onSuccess?: () => void;
  }) => void;
  setCurrentStep: (step: CheckoutStep) => void;
  setCheckoutId: (checkoutId: string | undefined) => void;
  closeCheckoutModal: () => void;
};

const initialState = {
  isOpen: false,
  eventId: undefined,
  initialPromoCode: undefined,
  initialTicketTypeId: undefined,
  currentStep: 'ticketSelection',
  checkoutId: undefined,
  onSuccess: () => {},
} as const;

export const useCheckoutModalStore = create<CheckoutModalState>((set) => ({
  ...initialState,

  openCheckoutModal: ({
    eventId,
    initialPromoCode,
    initialTicketTypeId,
    currentStep = 'ticketSelection',
    checkoutId,
    onSuccess,
  }) => {
    set({
      isOpen: true,
      eventId,
      initialPromoCode,
      initialTicketTypeId,
      currentStep,
      checkoutId,
      onSuccess,
    });
  },

  setCurrentStep: (step) => {
    set({ currentStep: step });
  },

  closeCheckoutModal: () => {
    set(initialState);
  },

  setCheckoutId: (checkoutId: string | undefined) => {
    set({ checkoutId });
  },
}));
